// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkEvaluationCard-cls1_jhj","cls2":"WorkEvaluationCard-cls2_AGx WorkEvaluationCard-cls1_jhj"};